import { inject, observer, Provider } from "mobx-react";
import React from "react";
import { NavigateFunction } from "react-router-dom";
import { Button, Confirm, Grid, Input } from "semantic-ui-react";
import withNavigation from "../../../hocs/withNavigation";
import { AgGridReact } from "@ag-grid-community/react/lib/agGridReact";
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css';
import { AgGridText } from '../../../core/agGridText';
import OpenItem from "../../../components/OpenItem";
import { RootStore } from "../../../stores/RootStore";
import { toJS } from "mobx";
import { ManufacturerInformationStore } from "./ManufacturerInformationStore";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


interface IStores {
    ManufacturerInformationStore: ManufacturerInformationStore
}

interface IManufacturerInformationPageProps {
    navigate?: NavigateFunction;
    RootStore?:RootStore
}

class ManufacturerInformationPage extends React.Component<IManufacturerInformationPageProps> {
    private stores: IStores

    constructor(props: any){
        super(props);

        this.stores = { ManufacturerInformationStore: new ManufacturerInformationStore(this.props.RootStore)}
    }

    componentDidMount(): void {
        this.stores.ManufacturerInformationStore.getManufacturerDescriptions()
    }

    public render() {
        const {ManufacturerInformationStore} = this.stores
        return <div>
            <Provider {...this.stores}>
            <div style={{ margin: 20, width: '95%' }}>
                        <Confirm open={ManufacturerInformationStore.isItemOpen}	      
                            style={{width: 1100}}                      
                            closeOnEscape={false} //disables closing the window by pressing ESC	
                            closeOnDimmerClick={false} //disables closing the window by clicking outside of it	                            
                            onCancel={() => {ManufacturerInformationStore.setItemOpenFalse();}}	
                            cancelButton="Mégse"
                            confirmButton={false}								
                            content={
                                <div style={{ padding: 30 }}>
                                    <div style={{marginRight: '20px'}}>
                                        <div style={{ display: 'flex'}}>
                                            <div style={{width: '33%'}}>
                                                <div style={{marginBottom: 5}}>
                                                    <label>Gyártó</label>
                                                </div>
                                                <Input value={ManufacturerInformationStore.selectedManufacturerDescriptionItem?.ManufacturerName} disabled/>
                                            </div>
                                            <div style={{width: '33%'}}>
                                                <div style={{marginBottom: 5}}>
                                                    <label>Módosító</label>
                                                </div>
                                                <Input value={ManufacturerInformationStore.selectedManufacturerDescriptionItem?.ModifiedByName} disabled/>
                                            </div>
                                            <div style={{width: '33%'}}>
                                                <div style={{marginBottom: 5}}>
                                                    <label>Módosítás dátuma</label>
                                                </div>
                                                <Input value={ManufacturerInformationStore.selectedManufacturerDescriptionItem?.ModifiedDateString} disabled/>
                                            </div>
                                        </div>
                                        
                                    </div>                                                                        
                                    <div>
                                        <label>Leírás</label>
                                        <span style={{ color: 'red', marginLeft: 2 }}>*</span>
                                    </div>
                                    <div>
                                        <Editor
                                            editorState={ManufacturerInformationStore.editorState}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            onEditorStateChange={(editorState: any) => {
                                                ManufacturerInformationStore.onEditorStateChange(editorState);
                                            }}
                                        />
                                    </div>
                                    <div style={{ textAlign: 'left' }}>
                                        <Button color="red" disabled={!ManufacturerInformationStore.getVodafoneCommissionItemCanBeSaved} onClick={() => {ManufacturerInformationStore.saveManufacturerDescription()}}>Mentés</Button>
                                    </div>
                                </div>
                            }
                        />
						<Grid>
							<Grid.Row centered>
                                <Grid.Column width={10}>                                    
                                    <Grid>                                        
                                        <Grid.Row centered>
                                            <Grid.Column width={16}>                                               
                                            <div id="grid" className="ag-theme-alpine" style={{width: '992px', height: '519px'}}>
                                                <AgGridReact											
                                                    rowData={toJS(ManufacturerInformationStore.manufacturerDescriptionItems)}											
                                                    columnDefs={ManufacturerInformationStore.columnDef}
                                                    localeText={AgGridText}
                                                    pagination={true}
                                                    paginationPageSize={10}
                                                    frameworkComponents={{ btnCellRendererOpenItem: OpenItem }}
                                                    gridOptions={{
                                                        paginationNumberFormatter: (params:any) => {
                                                        return  params.value.toLocaleString() ;
                                                      },
                                                    }}>	                                                    																			
                                                </AgGridReact>
                                            </div>                                              
                                            </Grid.Column>                                        
                                        </Grid.Row>
                                    </Grid>
                                </Grid.Column>                                
							</Grid.Row>
						</Grid>
					</div>
            </Provider>
        </div>
    }
}

export default withNavigation(inject('RootStore')(observer(ManufacturerInformationPage)));